import {defineAction} from 'redux-define';
import {createAction} from 'redux-actions';
import {browserHistory} from 'react-router';
import {put, takeLatest, select, take, call} from 'redux-saga/effects';

import {acceptInviteSaga} from 'api/invite';
import {getDeal} from 'api/deals';
import {getUserInfoSaga} from 'api/users';

import {selectEnv} from 'reducers/env';

const namespace = 'flows/lead/deal';

// Actions
const LOAD_LEAD_DEAL = defineAction('LOAD_LEAD_DEAL', namespace);
const SUBMIT_LEAD_DEAL = defineAction('SUBMIT_LEAD_DEAL', namespace);

export const loadLeadDeal = createAction(LOAD_LEAD_DEAL.ACTION);
export const submitLeadDeal = createAction(SUBMIT_LEAD_DEAL.ACTION);

// Lead Deal Saga
export function* leadDealSaga({payload}) {
  const {invite, deal} = payload;

  // Accept invite
  yield call(acceptInviteSaga, {payload: {id: invite.id}});

  // Load up user now that the user is definitely created
  yield call(getUserInfoSaga);

  // Load deal
  yield put(getDeal(deal));

  // Wait for user to agree to syndicate
  yield take(SUBMIT_LEAD_DEAL.ACTION);

  // Take them to the next page
  const env = yield select(selectEnv);
  if (env.web) {
    yield call(browserHistory.push, `/deals/${deal.id}`);
  }
}

export function* sagas() {
  yield takeLatest(LOAD_LEAD_DEAL.ACTION, leadDealSaga);
}



// WEBPACK FOOTER //
// ./mobile/shared/flows/lead/deal/index.js